import { IIndexMeta } from '@Modules/admin/archiving/containers/mixedHandlers/archivedTables/authorizationsConsultation/showDetails/IndexMeta';
import IndexMainUI from '@Modules/admin/archiving/components/forms/archivedTables/authorizationsConsultation/IndexMainUI';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import React from 'react';


type Props = {
  meta: IIndexMeta,
} 


const AuthorizationsConsultationUI = ({meta}: Props) => {    

  return (
    <>      
        <CC.Box my="4" mb='8'>
          <IndexMainUI meta={meta}/>        
        </CC.Box>
    </>    
  )
}

export default AuthorizationsConsultationUI;
